"use client";
import { AemHost } from "@/utils/constant";
import useMediaQuery from "@/utils/hooks/useMediaQuery";
import { useEffect, useState } from "react";

export const ResponsiveImage = ({
  mobileImage,
  tabletImage,
  src,
  imagePath,
}: any) => {
  const windowWidth = useMediaQuery() ?? 1920;
  const [imageUrl, setImageUrl] = useState<string>("");

  useEffect(() => {
    if (windowWidth <= 768) {
      const selectedImage = mobileImage || tabletImage || imagePath;
      setImageUrl(selectedImage ? AemHost + selectedImage : "");
    } else if (windowWidth <= 1024) {
      const selectedImage = tabletImage || imagePath;
      setImageUrl(selectedImage ? AemHost + selectedImage : "");
    } else {
      setImageUrl(src ? AemHost + (imagePath ?? "") : "");
    }
  }, [windowWidth, mobileImage, tabletImage, src]);
  return imageUrl;
};
